import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { theme } from './theme';

import Login from './pages/Login';
import Landing from './pages/Landing';
import PendingTeachers from './pages/admin_pages/PendingTeachers';
import TeacherDetail from './pages/admin_pages/TeacherDetail';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PolicyAndTermsOfUse from './pages/PolicyAndTermsOfUse';
import NotFound from './pages/NotFound';
import AdminLayout from './pages/admin_pages/AdminLayout';

// Assuming you have a Dashboard component. If PendingTeachers *is* your dashboard, 
// you can swap it into the index route below!
import Dashboard from './pages/admin_pages/Dashboard'; 
import DisputeManager from './pages/admin_pages/DisputeManager';
import Transactions from './pages/admin_pages/Transactions';
import Configuration from './pages/admin_pages/Configuration';
import NewsFeed from './pages/admin_pages/NewsFeed';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <Router>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/policy_and_terms_of_use" element={<PolicyAndTermsOfUse />} />

                        <Route 
                            path="/admin" 
                            element={
                                <ProtectedRoute>
                                    <AdminLayout />
                                </ProtectedRoute>
                            }
                        >
                            {/* <Route index element={<Dashboard />} />  */}
                            <Route index element={<DisputeManager />} /> 
                            <Route path="transactions" element={<Transactions />} /> 
                            <Route path="configuration" element={<Configuration />} /> 
                            <Route path="newsfeed" element={<NewsFeed />} /> 
                            
                            <Route path="pending-teachers" element={<PendingTeachers />} />
                            <Route path="teacher/:teacherId" element={<TeacherDetail />} />
                        </Route>

                        {/* catch all for 404 */}
                        <Route path="/*" element={<NotFound />} />
                    </Routes>
                </Router>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;